import Tooltip from '../../components/layout/Tooltip';

const img = require('../../assets/' + process.env.REACT_APP_LOGO);
export default function Header() {
    return (
        <header className="z-50 bg-white px-4 sm:px-6 fixed w-full border-b-2 flex justify-between items-center py-2">
            <img className="relative h-12" src={img} alt="logo"/>
            <a onClick={() => {
                sessionStorage.clear()
            }} href="/" className="group">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-500 hover:text-blue-800"
                     fill="none"
                     viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                          d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
                </svg>
                <Tooltip text='Sair'/>
            </a>
        </header>
    )
}
